import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import loading, { ExtraModelsFromLoading, LoadingConfig } from '@rematch/loading';
import { createBrowserHistory } from 'history';
// import { logoutMiddleware } from './middlewares/logoutMiddleware';
import models, { RootModel } from './models';
type FullModel = RootModel & ExtraModelsFromLoading<RootModel>;

export const history = createBrowserHistory();

const loadingPlugin = loading<RootModel, FullModel, LoadingConfig>();

export const store = init<RootModel, FullModel>({
  plugins: [loadingPlugin],
  models,
  redux: {
    // middlewares: [logoutMiddleware],
    rootReducers: {
      resetStore: () => undefined
    }
  }
});

export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type iRootState = RematchRootState<FullModel>;

export const dispatchResetStore = () => store.dispatch({ type: 'resetStore' });
